import { render } from "./EditorialFlairVideo.vue?vue&type=template&id=495ef404&scoped=true"
import script from "./EditorialFlairVideo.vue?vue&type=script&lang=js"
export * from "./EditorialFlairVideo.vue?vue&type=script&lang=js"

import "./EditorialFlairVideo.vue?vue&type=style&index=0&id=495ef404&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495ef404"]])

export default __exports__